export interface SimpleAddressDetails {
  country?: string;
  state?: string;
  city: string;
  address?: string;
  zip?: string;
  formattedAddress: string;
}

const CITY_TYPES = [
  "locality",
  "postal_town",
  "neighborhood",
  "sublocality",
  "postal_village",
  "administrative_area_level_3",
  "administrative_area_level_2"
];

export function extractAddressDetails(
  place: google.maps.places.PlaceResult | null
): SimpleAddressDetails {
  const comps = place?.address_components ?? [];

  const components: Record<string, string> = {};
  for (const comp of comps) {
    for (const type of comp.types) {
      components[type] = comp.short_name;
    }
  }

  const country = components["country"];
  const state = components["administrative_area_level_1"];
  const route = components["route"];
  const number = components["street_number"];
  const zip = components["postal_code"];

  const address = number && route ? `${number} ${route}` : route;

  let city = CITY_TYPES.map((t) => components[t]).find((v) => !!v) || "";

  if (!city && place?.formatted_address) {
    city = place.formatted_address.split(",")[0];
  }

  const formattedAddress =
    place?.formatted_address || [address, city, state, zip, country].filter(Boolean).join(", ");

  return {
    country,
    state,
    city,
    address,
    zip,
    formattedAddress
  };
}
